import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpersSettings {
    static customFieldsOBJ(settings) {
        if(settings == null) return null;
        const obj = {};   
        const arraySettings = JSON.parse(settings).custom_fields   
        for (let i = 0; i < arraySettings.length; i++) {
          const key = `custom_fields_${i + 1}`;
          const valor = arraySettings[i][key];
          obj[key] = valor;
        }      
        return obj;
      }
    
    static isInIframe(){
      return window.self !== window.top;
    }
}